export const Bell01Icon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.7952 17.5C8.38281 18.0186 9.15468 18.3333 10.0001 18.3333C10.8454 18.3333 11.6173 18.0186 12.2049 17.5M15.0001 6.66663C15.0001 5.34054 14.4733 4.06877 13.5356 3.13109C12.5979 2.19341 11.3261 1.66663 10.0001 1.66663C8.67397 1.66663 7.4022 2.19341 6.46452 3.13109C5.52684 4.06877 5.00006 5.34054 5.00006 6.66663C5.00006 9.24178 4.35045 11.0049 3.62478 12.1711C3.01266 13.1549 2.7066 13.6467 2.71783 13.7839C2.73025 13.9359 2.76244 13.9938 2.88487 14.0846C2.99544 14.1666 3.49388 14.1666 4.49077 14.1666H15.5093C16.5062 14.1666 17.0047 14.1666 17.1152 14.0846C17.2377 13.9938 17.2699 13.9359 17.2823 13.7839C17.2935 13.6467 16.9875 13.1549 16.3753 12.1711C15.6497 11.0049 15.0001 9.24178 15.0001 6.66663Z"
      stroke="#667085"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
